module.exports = __webpack_public_path__ + "static/img/title_CNTW.cf2deac.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/login/title_CNTW.png
// module id = 8IxK
// module chunks = 202